import VGListener from "./src/vg";
import YandexMetrika from './src/modules/ym';

(function ($) {
	$(window).on('load', function() {
		VGListener.onLoad();
	});

	$(window).scroll(function () {
		VGListener.onScroll($(this));
	});

	$(document).ready(function () {
		VGListener.onReady();
	});

	$(window).resize(function () {
		VGListener.onResize($(this));
	});
})(jQuery);

// Modules
require ('./src/modules/social');
require('./src/modules/ym');
require('./src/modules/bg');
require('./src/modules/video');
require('./src/modules/svgGenerator');

window.vgp = require('../../../modules/index.esm');
window.ymetrika = new YandexMetrika();

// [[vegas]]